import React, { Component } from "react";
import { Row, Col, InputGroup, DropdownButton, FormControl, Dropdown } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';

class QuestionOptUserInputText extends Component {
    // constructor(props) {
    //     super(props);
    // }

    render() {
        const data=this.props.data;
        return (
            <label className="w-100 underline">{data}</label>
        );
    }
}

export default QuestionOptUserInputText;